module.exports = __webpack_public_path__ + "img/palatine_b3.2698e8ba.jpg";